import React from "react";
import { FileText } from "@phosphor-icons/react";
import { RenovationDocumentsList } from "screens/renovationDocuments/RenovationDocumentsList";

interface PartFinancialDocumentsSectionProps {
  /** The project part being viewed. */
  part: { id: number | string } | null | undefined;
  /** Project id (used to scope downstream queries — the part's project). */
  projectId?: number | string | null;
  /** Building id (most specific scope, used for the underlying queries). */
  buildingId?: string | null;
}

/**
 * Embedded subset of the financiële-documenten view scoped to a single
 * project part.  Reuses RenovationDocumentsList in `embedded` mode with the
 * `lockedProjectPartId` prop so:
 *   - The underlying data, stats, and pagination are filtered server-side by
 *     this project part.
 *   - The "Project Part" filter chip is hidden (user cannot escape scope).
 *   - The page-level header / import buttons are suppressed and the FilterBar
 *     does NOT push state into the URL (host page owns the route).
 */
export const PartFinancialDocumentsSection: React.FC<
  PartFinancialDocumentsSectionProps
> = ({ part, projectId, buildingId }) => {
  if (!part?.id) return null;

  return (
    <div className="border-neutral-primary/20 overflow-hidden rounded-lg border bg-white shadow-sm">
      <div className="border-neutral-primary/10 flex items-center gap-2 border-b px-4 py-3">
        <FileText size={18} weight="duotone" className="text-moss-primary" />
        <h3 className="text-neutral-primary text-base font-semibold">
          Financiële documenten
        </h3>
      </div>

      <RenovationDocumentsList
        embedded
        lockedProjectPartId={Number(part.id)}
        lockedProjectId={projectId ? Number(projectId) : undefined}
        buildingId={buildingId || undefined}
      />
    </div>
  );
};

export default PartFinancialDocumentsSection;
